// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@sc/Overrides/Components/FindLocationModal";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

findLocationModalStyles.searchButton = {
    ...findLocationModalStyles.searchButton,
    size: 36,
};

findLocationModalStyles.searchRadiusGridItem = {
    ...findLocationModalStyles.searchRadiusGridItem,
    width: 8,
    css: css`
        margin-top: 0;
    `,
};

findLocationModalStyles.searchButtonGridItem = {
    ...findLocationModalStyles.searchButtonGridItem,
    width: 4,
};

findLocationModalStyles.searchResultPhoneGridItem = {
    ...findLocationModalStyles.searchResultPhoneGridItem,
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.searchResultPhoneLink = {
    ...findLocationModalStyles.searchResultPhoneLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
};

findLocationModalStyles.selectedWarehousePhoneLink = {
    ...findLocationModalStyles.selectedWarehousePhoneLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
    css: css`
        padding-top: 5px;
    `,
};

findLocationModalStyles.selectedWarehouseLink = {
    ...findLocationModalStyles.selectedWarehouseLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
    css: css`
        padding-top: 5px;
    `,
};

findLocationModalStyles.selectedWarehouseGoogleMapsDirectionLink = {
    ...findLocationModalStyles.selectedWarehouseGoogleMapsDirectionLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
    css: css`
        padding-top: 5px;
    `,
};

findLocationModalStyles.searchResultLinksOffsetGridItem = {
    ...findLocationModalStyles.searchResultLinksOffsetGridItem,
    width: 0,
};

findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    ...findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem,
    width: 4,
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.searchResultDistanceGridItem = {
    ...findLocationModalStyles.searchResultDistanceGridItem,
    width: 4,
};

findLocationModalStyles.warehouseDistanceDisplayText = {
    ...findLocationModalStyles.warehouseDistanceDisplayText,
    css: css`
        white-space: nowrap;
    `,
};

findLocationModalStyles.warehouseGoogleMapsDirectionLink = {
    ...findLocationModalStyles.warehouseGoogleMapsDirectionLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
};

findLocationModalStyles.searchResultHoursGridItem = {
    ...findLocationModalStyles.searchResultHoursGridItem,
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.searchResultHoursGridItem = {
    ...findLocationModalStyles.searchResultHoursGridItem,
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.warehouseHoursLink = {
    ...findLocationModalStyles.warehouseHoursLink,
    typographyProps: {
        size: 16,
        weight: "normal",
    },
};

findLocationModalStyles.searchResultLinksAndDistanceContainer = {
    ...findLocationModalStyles.searchResultLinksAndDistanceContainer,
    css: css`
        width: 100%;
        padding: 0;
        margin: 0;
        margin-left: 60px;

        ${xScreen("lte", "md")} {
            margin-left: 100px;
        }
        ${xScreen("lte", "sm")} {
            margin-left: 90px;
        }
        ${xScreen("lte", "xs")} {
            margin-left: 0;
            margin-top: 10px;
        }
    `,
};

findLocationModalStyles.searchResultSelectGridItem = {
    ...findLocationModalStyles.searchResultSelectGridItem,
    css: css`
        justify-content: flex-end;
    `,
};

findLocationModalStyles.searchGeoLocationGridItem = {
    width: 12,
    css: css`
        padding-bottom: 10px;
    `,
};
